// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1_Nr8","cls2":"QuestionStyles-cls2__bM QuestionStyles-cls1_Nr8"};